export const rem = value => `${value}rem`;
export const vh = value => `${value}vh`;
export const vw = value => `${value}vw`;
export const toREM = value => typeof value === 'string' || value === 0 ? `${value}` : rem(value);
// trbl = top, right, bottom, left
export const trbl = (top, right, bottom, left) => `${toREM(top)} ${toREM(right)} ${toREM(bottom)} ${toREM(left)}`;
// txb = top, x, bottom
// eslint-disable-next-line id-length
export const txb = (top, x, bottom) => `${toREM(top)} ${toREM(x)} ${toREM(bottom)}`;
// eslint-disable-next-line id-length
export const yx = (y, x) => `${toREM(y)} ${toREM(x)}`;
export const border = (width, style, colour) => `${width}px ${style} ${colour}`;
const pxToRem = (...sizes) => sizes.map(size => `${size / 16}rem`).join(' ');
const units = { rem, vh, vw, trbl, txb, yx, border, pxToRem };
export { units };
